export default {
  "content": "<path d=\"M21.759 3.65l-6 7a1 1 0 01-1.518 0l-3-3.5 1.518-1.3L15 8.463l5.241-6.115L21.76 3.65z\" fill=\"#7B61FF\"/><path d=\"M15.5 4H6v16h1v2H5a1 1 0 01-1-1V3a1 1 0 011-1h10.5v2zM11 22H9v-2h2v2zM15 22h-2v-2h2v2zM20 21a1 1 0 01-1 1h-2v-2h1v-8.5h2V21z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};